var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomSourceEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.674.327L17.005 23l-5.668-4.25L7.085 23v-7.085L18.423 4.578 4.25 13.08 0 10.247z",
    fill: "#797D85",
    fillRule: "evenodd",
    opacity: 0.99
  })));
}
export default SvgCustomSourceEmail;